import React from "react";
import { type IFormularioInformacionProyectoVistaProps } from "../interfaces";
import {
    TextInput,
    Grid,
    Box,
    Divider,
    Text,
    Select,
    Group,
    Button
} from "@mantine/core";
import GooglePlacesAutocomplete from "../../../globales/componentes/geolocalizacion/GooglePlacesAutocomplete";
import { MapaVista } from "../../../globales/componentes/mapa/mapaVista";
import { IconAt, IconBuildingSkyscraper, IconDeviceFloppy, IconLabel, IconLocationPin, IconMapPin2, IconNumber, IconPencilCheck, IconPhone, IconRoute, IconTimezone, IconWorldPin } from "@tabler/icons-react";
import { useProyecto } from "../contextoProyecto";
// import { Autocomplete, TextField } from "@mui/material";

const FormularioInformacionProyectoVista: React.FunctionComponent<IFormularioInformacionProyectoVistaProps> = ({
    manejarCambioValorProyecto,
    entidadesRegistro,
    guardarEditarProyecto,
    agregarError,
    errores,
    regexLat,
    regexLng,
    pantallaCompleta
}) => {

    const { proyecto, setProyecto } = useProyecto();
    return (
        <Box
            style={{
                display: "flex",
                flexDirection: "column",
                height: pantallaCompleta ? "80vh" : "60vh",
            }}>
            <Box
                p="md"
                style={{
                    flex: 1,
                    overflowY: "auto",
                    overflowX: 'hidden',
                }}
            >
                {/* Información Básica */}
                <Text fw={600} mb="xs">
                    Información Básica
                </Text>
                <Grid gutter="sm">
                    <Grid.Col span={{ base: 12, md: 6 }}>
                        <TextInput
                            label="Nombre del Proyecto"
                            placeholder="Nombre del Proyecto"
                            name="NombreProyecto"
                            size="xs"
                            leftSection={<IconLabel size={14} />}
                            maxLength={50}
                            value={proyecto.Nombre || ""}
                            onChange={(event) => {
                                manejarCambioValorProyecto("Nombre", event.target.value)
                                if (event.target.value === '') {
                                    agregarError('Nombre', 'Este campo es requerido')
                                }
                                else {
                                    agregarError('Nombre', '')
                                }
                            }}
                            error={errores.Nombre}
                            required
                        />
                    </Grid.Col>
                    <Grid.Col span={{ base: 12, md: 6 }}>
                        <TextInput
                            label="Identificación del Proyecto"
                            placeholder="Identificación del Proyecto"
                            name="NitProyecto"
                            size="xs"
                            leftSection={<IconNumber size={14} />}
                            maxLength={30}
                            value={proyecto.NitProyecto || ""}
                            onChange={(event) => {
                                manejarCambioValorProyecto("NitProyecto", event.currentTarget.value)
                                if (event.target.value === '') {
                                    agregarError('NitProyecto', 'Este campo es requerido')
                                }
                                else {
                                    agregarError('NitProyecto', '')
                                }
                            }}
                            error={errores.NitProyecto}
                            required
                        />
                    </Grid.Col>
                </Grid>

                <Divider my="lg" />

                {/* Ubicación */}
                <Text fw={600} mb="sm">
                    Ubicación
                </Text>
                <Grid gutter="sm">
                    <Grid.Col span={6}>
                        <Grid gutter="sm">
                            <Grid.Col span={{ base: 12, md: 4 }}>
                                <Select
                                    label="País"
                                    placeholder="País"
                                    size="xs"
                                    required
                                    leftSection={<IconWorldPin size={14} />}
                                    comboboxProps={{ zIndex: 5000 }}
                                    data={entidadesRegistro.Paises.map(p => ({
                                        value: p.Id.toString(),
                                        label: p.Nombre,
                                    }))}
                                    clearable
                                    nothingFoundMessage="No se encontraron países"
                                    value={proyecto.PaisId !== null ? proyecto.PaisId.toString() : undefined}
                                    onChange={(value) => {
                                        manejarCambioValorProyecto("PaisId", value ? Number(value) : 0)
                                        // manejarCambioValorProyecto("Pais", value ? entidadesRegistro.Paises.find(p => p.Id.toString() === value) || estadoInicialPais : estadoInicialPais)
                                        if (value === null) {
                                            agregarError('PaisId', 'Selecciona un país')
                                        }
                                        else {
                                            agregarError('PaisId', '')
                                        }
                                    }}
                                    error={errores.PaisId}
                                />

                            </Grid.Col>

                            <Grid.Col span={{ base: 12, md: 8 }}>
                                <GooglePlacesAutocomplete
                                    label="Dirección"
                                    size="xs"
                                    country={entidadesRegistro.Paises.find(p => p.Id === proyecto.PaisId)?.CodigoISO || ''}
                                    leftSection={<IconLocationPin size={14} />}
                                    disabled={proyecto.PaisId === 0}
                                    placeholder="Escribe una dirección"
                                    value={proyecto.Direccion || ""}
                                    onChange={(value) => {
                                        manejarCambioValorProyecto("Direccion", value);
                                        setProyecto(prev => ({
                                            ...prev,
                                            Latitud: '',
                                            Longitud: '',
                                        }));
                                    }}
                                    onSelect={({ description, lat, lng }) => {
                                        setProyecto(prev => ({
                                            ...prev,
                                            Direccion: description,
                                            Latitud: String(lat),
                                            Longitud: String(lng),
                                        }));
                                    }}
                                    required
                                />
                            </Grid.Col>
                            <Grid.Col span={{ base: 12, md: 6 }}>
                                <TextInput
                                    label="Latitud"
                                    placeholder="Latitud"
                                    size="xs"
                                    required
                                    value={proyecto.Latitud ? proyecto.Latitud.toString() : ''}
                                    onChange={(event) => {
                                        const value = event.currentTarget.value;
                                        if (/^-?\d*\.?\d*$/.test(value)) {
                                            manejarCambioValorProyecto("Latitud", value);
                                        }
                                        if (value === '') {
                                            agregarError('Latitud', 'Este campo es requerido')
                                        }
                                        else {
                                            agregarError('Latitud', '')
                                        }
                                    }}
                                    error={
                                        (proyecto.Latitud !== "" &&
                                            proyecto.Latitud && !regexLat.test(proyecto.Latitud.toString())
                                            ? "Latitud inválida (rango -90 a 90)"
                                            : undefined) || errores.Latitud
                                    }
                                />

                            </Grid.Col>
                            <Grid.Col span={{ base: 12, md: 6 }}>
                                <TextInput
                                    label="Longitud"
                                    placeholder="Longitud"
                                    size="xs"
                                    required
                                    value={proyecto.Longitud ? proyecto.Longitud.toString() : ''}
                                    onChange={(event) => {
                                        const value = event.currentTarget.value;

                                        // Solo permitir "-", números y punto
                                        if (/^-?\d*\.?\d*$/.test(value)) {
                                            manejarCambioValorProyecto("Longitud", value);
                                        }

                                        // Validar requerido
                                        if (value === '') {
                                            agregarError('Longitud', 'Este campo es requerido');
                                        } else {
                                            agregarError('Longitud', '');
                                        }
                                    }}
                                    error={
                                        (proyecto.Longitud !== "" &&
                                            proyecto.Longitud && !regexLng.test(proyecto.Longitud.toString())
                                            ? "Longitud inválida (rango -180 a 180)"
                                            : undefined) || errores.Longitud
                                    }
                                />
                            </Grid.Col>
                        </Grid>
                    </Grid.Col>
                    <Grid.Col span={6} style={{ zIndex: 10 }}>
                        <MapaVista
                            popupText={proyecto.Direccion || ""}
                            latitud={proyecto.Latitud && !regexLat.test(proyecto.Latitud.toString()) ? 0 : Number(proyecto.Latitud)}
                            longitud={proyecto.Longitud && !regexLng.test(proyecto.Longitud.toString()) ? 0 : Number(proyecto.Longitud)}
                            height="250px" />
                    </Grid.Col>
                </Grid>

                <Divider my="lg" />

                {/* Contacto */}
                <Text fw={600} mb="sm">
                    Contacto
                </Text>
                <Grid gutter="sm">
                    <Grid.Col span={{ base: 12, md: 6 }}>
                        <TextInput
                            label="Teléfono"
                            placeholder="Teléfono"
                            name="Telefono"
                            leftSection={<IconPhone size={14} />}
                            size="xs"
                            maxLength={20}
                            value={proyecto.Telefono || ""}
                            onChange={(event) => {
                                const value = event.currentTarget.value;
                                const soloNumeros = value.replace(/\D/g, "");
                                manejarCambioValorProyecto("Telefono", soloNumeros);
                            }}
                        />

                    </Grid.Col>
                    <Grid.Col span={{ base: 12, md: 6 }}>
                        <TextInput
                            label="Correo"
                            leftSection={<IconAt size={14} />}
                            placeholder="Correo"
                            name="Correo"
                            size="xs"
                            maxLength={150}
                            value={proyecto.CorreoNotificaciones || ""}
                            onChange={(event) => {
                                const value = event.currentTarget.value;
                                manejarCambioValorProyecto("CorreoNotificaciones", value);
                            }}
                            type="email"
                            error={
                                proyecto.CorreoNotificaciones &&
                                    !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(proyecto.CorreoNotificaciones)
                                    ? "Correo inválido"
                                    : null
                            }
                        />


                    </Grid.Col>
                </Grid>

                <Divider my="lg" />

                {/* Otros Datos */}
                <Text fw={600} mb="sm">
                    Otros Datos
                </Text>
                <Grid gutter="sm">
                    <Grid.Col span={{ base: 12, md: 6 }}>
                        <Select
                            label="Regional"
                            placeholder="Regional"
                            searchable
                            disabled={proyecto.PaisId === 0}
                            size="xs"
                            leftSection={<IconTimezone size={14} />}
                            required
                            comboboxProps={{ zIndex: 5000 }}
                            data={entidadesRegistro.Regionales.map(c => ({
                                value: c.Id.toString(),
                                label: c.Nombre,
                            }))}
                            nothingFoundMessage="No se encontraron regionales"
                            value={proyecto.RegionalId ? proyecto.RegionalId.toString() : undefined}
                            clearable
                            error={errores.RegionalId}
                            onChange={(value) => {
                                manejarCambioValorProyecto("RegionalId", value ? Number(value) : 0)
                                // manejarCambioValorProyecto("Regional", value ? entidadesRegistro.Regionales.find(c => c.Id.toString() === value) || estadoInicialRegional : estadoInicialRegional)
                                if (value === null) {
                                    agregarError('RegionalId', 'Selecciona una regional')
                                }
                                else {
                                    agregarError('RegionalId', '')
                                }
                            }}
                        />
                    </Grid.Col>
                    <Grid.Col span={{ base: 12, md: 6 }}>
                        <Select
                            label="Zona"
                            placeholder="Zona"
                            searchable
                            size="xs"
                            required
                            leftSection={<IconMapPin2 size={14} />}
                            comboboxProps={{ zIndex: 5000 }}
                            data={entidadesRegistro.Zonas.map(c => ({
                                value: c.Id.toString(),
                                label: c.Nombre,
                            }))}
                            nothingFoundMessage="No se encontraron zonas"
                            value={proyecto.ZonaId ? proyecto.ZonaId.toString() : undefined}
                            clearable
                            error={errores.ZonaId}
                            onChange={(value) => {
                                manejarCambioValorProyecto("ZonaId", value ? Number(value) : '')
                                // manejarCambioValorProyecto("Zona", value ? entidadesRegistro.Zonas.find(c => c.Id === Number(value)) || estadoInicialZona : estadoInicialZona)
                                if (value === null) {
                                    agregarError('ZonaId', 'Selecciona una zona')
                                }
                                else {
                                    agregarError('ZonaId', '')
                                }
                            }}
                        />
                    </Grid.Col>
                    <Grid.Col span={{ base: 12, md: 6 }}>
                        <TextInput
                            label="Ruta"
                            placeholder="Ruta"
                            name="Ruta"
                            required
                            leftSection={<IconRoute size={14} />}
                            size="xs"
                            value={proyecto.Ruta || ""}
                            onChange={(event) =>
                                manejarCambioValorProyecto("Ruta", event.currentTarget.value)
                            }
                        />
                    </Grid.Col>

                    <Grid.Col span={{ base: 12, md: 6 }}>
                        <Select
                            label="Ciudad"
                            placeholder="Ciudad"
                            searchable
                            disabled={proyecto.PaisId === 0}
                            size="xs"
                            leftSection={<IconBuildingSkyscraper size={14} />}
                            comboboxProps={{ zIndex: 5000 }}
                            data={entidadesRegistro.Ciudades.map(c => ({
                                value: c.Id.toString(),
                                label: c.Nombre,
                            }))}
                            nothingFoundMessage="No se encontraron ciudades"
                            value={proyecto.CiudadId !== null ? proyecto.CiudadId.toString() : undefined}
                            clearable
                            onChange={(value) => {
                                manejarCambioValorProyecto("CiudadId", value ? Number(value) : 0)
                            }}
                        />
                    </Grid.Col>
                </Grid>
            </Box>
            <Box
                style={{
                    backgroundColor: "#fff",
                }}
            >
                <Group justify="flex-end" pt="sm">
                    <Button
                        onClick={guardarEditarProyecto}
                        color="primary"
                        variant="filled"
                        size='compact-sm'
                        radius="lg"
                        rightSection={proyecto.Id ? <IconPencilCheck opacity={100} color="white" size={15} /> : <IconDeviceFloppy opacity={100} color="white" size={15} />}
                    >
                        <Text fw={500} fz={11}>{proyecto.Id !== 0 ? "Editar Proyecto" : "Guardar Proyecto"}</Text>
                    </Button>


                </Group>
            </Box>
        </Box>
    );
}

export default FormularioInformacionProyectoVista;